import React from "react";
import axios from "axios";
import GoogleAd from "../Adsense/GoogleAd";
import severUrl from "../../api";
import { Tooltip as ReactTooltip } from "react-tooltip";
import ReloadModal from "../modal/ReloadModal";

class LeftPanel extends React.Component {
  state = {
    recents: [],
    related: [],
    loaded: false,
    apiError: false
  };

  componentDidMount() {
    // make fetch request
    fetch(severUrl + `blog/list/recent/`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);

        this.setState({ recents: data });
      }).catch(
        (error) => {
          console.log(error)
          this.setState({apiError: true})
        }
      )
      ;

    if (this.props.slug) {
      this.setState({ loaded: true })
      var bodyFormData = new FormData();
      bodyFormData.append("slug", this.props.slug);
      localStorage.setItem("slug", this.props.slug);

      axios
        .post(
          severUrl + "blog/" + this.props.slug + "/list/relative/",
          bodyFormData
        )
        .then((response) => response.data)
        .then((data) => {
          console.log(data)
          this.setState({ related: data });
        }).catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            // console.log('Error', error.message);
          }
          // console.log(error.config);
        });;
    }

  }

  handleOnclick = () => {
    window.location.href = "/Coffee";
  };

  render() {
    if (!this.state.loaded) {
      return (

        <div
          style={{
            gridArea: "LeftPanel",
            gridColumn: "1/6",
            // alignContent: "center",
            textAlign: "justify",
            marginRight: "10px",
            marginTop: "40px",
          }}
        >
          <button className="support-me-btn" style={{ width: "100%", fontWeight: "550" }} onClick={this.handleOnclick}>
            <a >Support me a coffe</a>
          </button>
          <a data-tooltip-id="my-tooltip-3" style={{fontSize: "12px" }}> Write for paid</a>
          <ReactTooltip
            id="my-tooltip-3"
            place="bottom"
            content="on planning"
          />
          <span class="brmedium"></span>
          <h4>
            Newest
          </h4>
          {Array.from(this.state.recents).map((p) => (
            <>
              <a className="a_title" href={"/" + p.slug}>{p.title}</a>
              <span class="brmedium"></span>
            </>
          ))}
          <a className="a_title" style={{ color: "#052e9d !important" }} href='http://localhost:3000/weight-decays-of-pcg-without-swap-step-for-simplex-like-polytope-with-fixed-step-size'>Weight decays of PCG without swap step for Simplex Like Polytope with Fixed Step Size
          </a>
          <span class="brmedium"></span>
          <a className="a_title" style={{ color: "#052e9d !important" }} href='http://localhost:3000/weight-decays-of-pcg-without-swap-step-for-simplex-like-polytope-with-fixed-step-size'>
          Parallel Programming Pariwise Conditional Gradient for Kernel Herding with Cuda C
          </a>
          <span class="brmedium"></span>
          <a className="a_title" style={{ color: "#052e9d !important" }} href='http://localhost:3000/weight-decays-of-pcg-without-swap-step-for-simplex-like-polytope-with-fixed-step-size'>
          Implement Sequential Bayesian Quadrature Using Python and experiment on real dataset
          </a>
          <span class="brmedium"></span>
          <a className="a_title" style={{ color: "#052e9d !important" }} href='http://localhost:3000/weight-decays-of-pcg-without-swap-step-for-simplex-like-polytope-with-fixed-step-size'>
          Training two-class L2 Support Vector Machine By Several Variants of Conditional Gradient
          </a>
          <span class="brmedium"></span>
          <a className="a_title" style={{ color: "#052e9d !important" }} href='http://localhost:3000/weight-decays-of-pcg-without-swap-step-for-simplex-like-polytope-with-fixed-step-size'>
          Weight decays of PCG without swap step for Simplex Like Polytope with Fixed Step Size
          </a>
          <span class="brmedium"></span>
          <a className="a_title" style={{ color: "#052e9d !important" }} href='http://localhost:3000/weight-decays-of-pcg-without-swap-step-for-simplex-like-polytope-with-fixed-step-size'>
          Matrix Completion using Blended Pairwise Condition Conditional Gradient over Spectrahedron
          </a>
          <span class="brmedium"></span>
          <a className="a_title" style={{ color: "#052e9d !important" }} href='http://localhost:3000/weight-decays-of-pcg-without-swap-step-for-simplex-like-polytope-with-fixed-step-size'>
          Portfolio Optimization using Lazy Blended Pairwise Condition Conditional Gradient over probability simplex
          </a>
          <span class="brmedium"></span>
          <a className="a_title" style={{ color: "#052e9d !important" }} href='http://localhost:3000/weight-decays-of-pcg-without-swap-step-for-simplex-like-polytope-with-fixed-step-size'>
          Kernel Herding using Pairwise Conditional Gradients on Spatial Network Dataset

          </a>
          <span class="brmedium"></span>
        </div>
      )
    }
    return (
      <div
        style={{
          gridArea: "LeftPanel",
          gridColumn: "1/6",
          // alignContent: "center",
          textAlign: "justify",
          marginRight: "10px",
          marginTop: "40px",
        }}
      >
        <button style={{ width: "100%", fontWeight: "550", fontSize: "14px" }} onClick={this.handleOnclick}>
          <a>Support me a coffe</a>
        </button>
        <span class="brmedium"></span>
        <h4>
          Newest
        </h4>
        {Array.from(this.state.recents).map((p) => (
          <>
            <a className="a_title" href={"/" + p.slug}>{p.title}</a>
            <span class="brmedium"></span>
          </>
        ))}
        {this.props.slug && (
          <>
            {this.state.related.length != 0 && (
              <>
                <h4>
                  Relative
                </h4>
              </>
            )}
            {Array.from(this.state.related).map((p) => (
              <>
                <a className="a_title" style={{ color: "#052e9d !important" }} href={"/" + p.slug}>{p.title}</a>
                <span class="brmedium"></span>
              </>
            ))}
          </>
        )}
        <GoogleAd
          classNames="GoogAd"
          slot="4978689198"
          googleAdId="ca-pub-3156532081104759"
        />
            {/* <ReloadModal isShowing={this.state.apiError} hide={(index) => this.toggle(0)} /> */}
      </div>
      
    );
  }
}

export default LeftPanel;
